<template>
  <div>
    <div class="modal__radarboard">
      <div class="modal__radarboard-item">
        <translated-text-component translation="num_of_vehicle15m" />:
        <div class="modal__radarboard-value">{{ lastStatus.num_of_vehicle15m || '-' }}</div>
      </div>
      <div class="modal__radarboard-item">
        <translated-text-component translation="num_of_vehicle1h" />: 
        <div class="modal__radarboard-value">{{ lastStatus.num_of_vehicle1h || '-' }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import { IModalData } from '@/services/layers/IModalData';
import moment from 'moment';

const TemplateModalRadarBoard: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const modalData: Ref<object> = ref({});
    const lastStatus: Ref<object> = ref({});

    onMounted(() => {
      const { metaData } = props.templateData;
      modalData.value = metaData;
      lastStatus.value = metaData.last_status;
    });

    return {
      modalData,
      lastStatus,
    };
  },
});
export default TemplateModalRadarBoard;
</script>

<style scoped lang="scss">
.modal__radarboard {
  display: flex;
  flex-direction: column;
  align-items: center;

  .modal__radarboard-item {
    .modal__radarboard-value {
      font-weight: bold;
      font-size: rem(20px);
      text-align: center;
    }
  }
}
</style>
